// Copyright © 2024 Move Closer

import { Component, Prop } from 'vue-property-decorator'

import { BootstrapBadge, BootstrapLink } from '../../../dsl/front'

import { ListWithAddonsMixin } from '../ui/ListWithAddonsMixin'

import { PublicationDate } from '../PublicationDate'
import { ReadMoreLink } from '../ReadMoreLink'
import { ReadingTime } from '../ReadingTime'
import { TextListItem } from '../TextListItem/TextListItem'
import { IWindow } from '@movecloser/front-core'
import { TileConfig } from '../Tile'

/**
 * TextList component with support for addons mixed within the list
 */
@Component({
  name: 'TextListWithAddons',
  components: { BootstrapBadge, BootstrapLink, PublicationDate, ReadMoreLink, ReadingTime, TextListItem },

  template: `
    <div v-if="items && items.length" class="text-list">
    <div class="text-list__container" :class="{ '--with-read-more' : readMoreLink }">
      <!-- Mixed articles and addons list -->
      <ul class="text-list__list list-unstyled">
        <template v-for="item in items">
          <!-- Article item -->
          <TextListItem
            v-if="item.type === 'article'"
            v-bind="tile"
            :item="item"
            :list-config="listConfig" />
          <!-- Addon item -->
          <li v-else-if="item.type === 'addon'" :key="item.key" class="text-list__addon-item">
            <component :is="getAddonComponent(item.data)" v-bind="getAddonProps(item.data)" />
          </li>
        </template>
      </ul>
      <!-- END | Mixed articles and addons list -->
    </div>

    <!-- "Read more" button -->
    <div v-if="readMoreLink" class="text-list__read-more-link">
      <ReadMoreLink :link="readMoreLink" />
    </div>
    </div>
  `
})
export class TextListWithAddons extends ListWithAddonsMixin {
  @Prop({ type: Boolean, default: false })
  public readonly withoutBadge!: boolean

  @Prop({ type: Boolean, default: false })
  public readonly showPublicationDate!: boolean

  @Prop({ type: Boolean, default: false })
  public readonly showReadingTime!: boolean

  @Prop({ type: Object, required: true })
  protected readonly windowService!: IWindow

  @Prop({ type: Object, required: true })
  protected readonly tile!: TileConfig

  public get showBadge (): boolean {
    if (!this.listConfig) {
      return false
    }

    if (typeof this.listConfig.showArticleTags === 'undefined') {
      return false
    }
    return this.listConfig.showArticleTags
  }
}
